var _style, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Video Play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.playWhiteOP{opacity:0.5;fill:#F3F3F3;}\r\n\t\t.playBlue{fill:#004B87;}\r\n\t\t.playWhite{fill:#FFFFFF;}\r\n\t")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "playWhiteOP",
    cx: 54.2,
    cy: 54.2,
    r: 48.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "playBlue",
    d: "M77.2,50.5L41.8,30c-0.9-0.5-2.1-0.5-3,0c-0.9,0.5-1.5,1.5-1.5,2.6v40.9c0,1.1,0.6,2.1,1.5,2.6 c0.5,0.3,1,0.4,1.5,0.4c0.5,0,1-0.1,1.5-0.4l35.4-20.5c0.9-0.5,1.5-1.5,1.5-2.6S78.1,51,77.2,50.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "playWhite",
    d: "M54.2,108.3C24.3,108.3,0,84,0,54.2C0,24.3,24.3,0,54.2,0c29.9,0,54.2,24.3,54.2,54.2 C108.3,84,84,108.3,54.2,108.3z M54.2,6C27.6,6,6,27.6,6,54.2c0,26.6,21.6,48.2,48.2,48.2c26.6,0,48.2-21.6,48.2-48.2 C102.3,27.6,80.7,6,54.2,6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/play-video.52abc8c446ad3b16087712ebedc5905b.svg";
export { ForwardRef as ReactComponent };